import React from "react";
import Stack from "@mui/material/Stack";
// import Roll from "react-awesome-reveal"
import Typography from "@mui/material/Typography";

const AboutDetail = () => {
  return (
    <Stack
      spacing={2}
      useFlexGap
      sx={{
        width: { xs: "100%", sm: "100%" },
        pt: { xs: 2, sm: 10 },
        pb: { xs: 2, sm: 10 },
      }}
    >
    {/* <Roll right> */}
      <Typography
        component="h1"
        variant="h1"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignSelf: "center",
          textAlign: "center",
          fontSize: { xs: "5rem", sm: "5rem" },
        }}
      >
        About Us
      </Typography>
      {/* </Roll> */}
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          lineHeight: "1.6", // Adjust the line height value as needed
          letterSpacing: "0.5px", // Adjust the letter spacing value as needed
          fontWeight: "bold", // Adjust the font weight value as needed (e.g., 'bold', 'normal', etc.)
          fontSize: "16px",
          gap: "20px", // Add gap between the images
          padding: "20px", // Add padding around the images
        }}
      >
        RESELTECH Reservoir Link Technology, located in Near PAF Colony,Opposite
        Govt. Primary School,Sohrab Wala Tehsil and District
        Mianwali,Pakistan. Also located in Reseltech, No. 199, Huqiao Road, Xindu District, Chengdu, China. Reservoir Link Technology, Pakistan, is a national
        high-tech enterprise with core competitiveness, vitality and sustained
        and rapid development.
        <br />
        Adhering to the service concept of integrity, innovation, kindness,
        honour and pragmatism, the company has formed a multi-business system
        with  AICD & AICV intelligent well water control oil production and
        completion technology as the core business, and sand control technology,
        stratified mining, intelligent column separation and other stimulation
        and transformation technologies as supplements. The company also acts as
        an agent for all oilfield instruments and equipment and has formed
        supporting services dominated by product research and development,
        program design and project management.
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignSelf="center"
        spacing={1}
        useFlexGap
        sx={{ pt: 2, width: { xs: "100%", sm: "auto" } }}
      >
        {/* <TextField
        id="outlined-basic"
        hiddenLabel
        size="small"
        variant="outlined"
        aria-label="Enter your email address"
        placeholder="Your email address"
        inputProps={{
          autocomplete: 'off',
          ariaLabel: 'Enter your email address',
        }}
      /> */}
        {/* <Button variant="contained" color="primary">
        Start now
      </Button> */}
      </Stack>
    </Stack>
  );
};

export default AboutDetail;
